import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";
import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";

export const dateFieldContainerStyle = style({
  minWidth: rem(120),
  flexShrink: 0,
});

export const sliderContainerStyle = style({
  position: "relative",
  flexGrow: 1,
  height: rem(60),
  pointerEvents: "none",
  userSelect: "none",
  width: "100%",
});

export const timelineStyle = style({
  position: "absolute",
  top: rem(18),
  left: 0,
  right: 0,
  height: rem(12),
  borderRadius: theme.borderRadiuses.xs,
  border: `1px solid ${theme.colors.defaultBorder}`,
});

export const labelsContainerStyle = style({
  position: "absolute",
  top: rem(42),
  width: "100%",
});

export const timeLabelContainerStyle = style({
  position: "absolute",
  top: rem(-28),
  left: rem(10),
  right: rem(10),
});

export const timeLabelIconStyle = style({
  marginRight: theme.spacings.xxs,
  marginBottom: rem(-2),
  verticalAlign: "baseline",
});

export const timeLabelStyle = recipe({
  base: {
    position: "absolute",
    whiteSpace: "nowrap",
    transform: "translateX(-50%)",
    padding: theme.spacings.xs,
    borderRadius: theme.borderRadiuses.xs,
    top: 0,
    background: theme.colors.onBackground,
    color: theme.colors.background,
  },
});

export const labelStyle = recipe({
  base: {
    position: "absolute",
    whiteSpace: "nowrap",
  },
  variants: {
    center: {
      true: {
        transform: "translateX(-50%)",
      },
    },
  },
});

export const hourMarkersContainerStyle = style({
  position: "absolute",
  top: rem(33),
  left: rem(10),
  right: rem(10),
  height: rem(6),
});

export const hourMarkerStyle = style({
  position: "absolute",
  top: 0,
  width: rem(1),
  height: "100%",
  background: theme.colors.defaultBorderHover,
  opacity: 0.5,
});

export const sliderInputStyle = style({
  position: "absolute",
  top: rem(16),
  width: "100%",
  cursor: "pointer",
  appearance: "none",
  background: "transparent",
  height: rem(16),
  zIndex: 3,
  pointerEvents: "auto",

  "::-webkit-slider-thumb": {
    appearance: "none",
    width: rem(20),
    height: rem(20),
    borderRadius: "50%",
    background: theme.colors.primary,
    boxShadow: `0 ${rem(2)} ${rem(4)} rgba(0, 0, 0, 0.2)`,
    cursor: "pointer",
  },

  "::-moz-range-thumb": {
    width: rem(20),
    height: rem(20),
    borderRadius: "50%",
    background: theme.colors.primary,
    border: "none",
    boxShadow: `0 ${rem(2)} ${rem(4)} rgba(0, 0, 0, 0.2)`,
    cursor: "pointer",
  },
});
